export const FHIRResourceSubTypeParamType_Dynamic = 'dynamic';
export const FHIRResourceSubTypeParamType_Fixed = 'fixed';
//# sourceMappingURL=types.js.map